import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container, TextField } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAlert } from "../../components/Alert";
export default function CreateLabTest() {
  const navigate = useNavigate();
  const [crops, setCrops] = useState([]);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const [selectedFileName, setSelectedFileName] = useState("");
  const { showAlert } = useAlert();

  const [searchParams] = useSearchParams();
  const labId = searchParams.get("labId");
  const cropId = searchParams.get("cropId");
  const [isEdit, setIsEdit] = useState(false);
  // useEffect(() => {
  //   loadTasks();
  // }, []);
  useEffect(() => {
    // Check if in edit mode
    if (labId) {
      fetchLabTestData(labId);
      setIsEdit(true);
    }
  }, [isEdit, labId]);

  useEffect(() => {
    api.get("/farmer/crops/").then((res) => {
      const _crops = res.data.map((f) => {
        const name = `${f.farmland?.farm_name} ${f.commodity?.name} [${f.sowing_date}]`;
        return { id: f.id, crop_name: name };
      });
      setCrops(_crops);
      if (cropId) {
        const selectedCrop = _crops.find(
          (crop) => crop.id === parseInt(cropId, 10)
        );
        if (selectedCrop) {
          setFormData((prevData) => ({
            ...prevData,
            crop_id: selectedCrop.id,
          }));
        }
      }
    });
  }, []);
  const fetchLabTestData = (labId) => {
    api
      .get(`/farmer/lab_test/${labId}/`)
      .then((response) => {
        if (response && response.data) {
          const labdata = response.data;
          const { lab_name, remarks, report_date, test_date } = labdata;
          setFormData({
            // crop_id,
            lab_name,
            remarks,
            report_date,
            test_date,
            crop_id: labdata.crop.id,
            lab_report: labdata.lab_report ? labdata.lab_report : "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching farm data:", error);
      });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        showAlert("error", t("Only PDF files are allowed."));
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        // 5MB size limit
        showAlert("error", t("File size must be less than 5MB."));
        return;
      }
      setFormData((prevData) => ({ ...prevData, lab_report: file }));
      setSelectedFileName(file.name);
    } else {
      showAlert("error", t("No file selected"));
    }
  };

  const createLabTest = () => {
    const fileFields = ["lab_report"];
    for (const field of fileFields) {
      if (!formData[field]) {
        alert(`Please upload ${field}`);
        return;
      }
    }

    const _formData = new FormData();
    for (const key in formData) {
      // For file inputs, ensure you are appending the file, not the FileList
      if (formData[key] instanceof FileList) {
        // Append the file if it exists, typically you would only send one file per field
        _formData.append(key, formData[key][0]);
      } else {
        // Do not submit empty file fields
        if (fileFields.includes(key) && typeof formData[key] === "string")
          continue;
        _formData.append(key, formData[key]);
      }
    }
    const apiRequest = isEdit
      ? api.patch(`/farmer/lab_test/${labId}/`, _formData)
      : api.post("/farmer/lab_test/", _formData);

    apiRequest
      .then((response) => {
        // alert("Lab test added successfully");
        console.log("Response from POST request:", response.data);
        showAlert(
          "success",
          isEdit ? "Updated Successfully" : "Lab test added successfully"
        );

        const redirectUrl = cropId ? `/farmer/crop/${cropId}` : "/";
        navigate(redirectUrl);
      })
      .catch((error) => {
        console.log(error);
        showAlert("error", "Error adding lab test");
      });
  };
  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Lab Test")}</CustomTitle>
            <FormControl fullWidth sx={{ marginTop: 2 }}>
              <InputLabel id="token-select-label">{t("Crop")}</InputLabel>
              <Select
                label={t("Crop")}
                name="crop_id"
                value={formData.crop_id || ""}
                onChange={handleChange}
                disabled={!!cropId} // Disable if cropId is provided in URL
              >
                {crops.map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.crop_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              margin="normal"
              required
              fullWidth
              label={t("Lab Name")}
              type="text"
              name="lab_name"
              value={formData.lab_name || ""}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              label={t("Test Date")}
              InputLabelProps={{ shrink: true }}
              name="test_date"
              value={formData.test_date || ""}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              label={t("Report Date")}
              name="report_date"
              InputLabelProps={{ shrink: true }}
              value={formData.report_date || ""}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              label={t("Remarks")}
              name="remarks"
              value={formData.remarks || ""}
              onChange={handleChange}
            />
            <Grid container sx={{ marginTop: "10px" }}>
              <Grid item xs={8}>
                <Typography style={{ fontSize: "12px", fontWeight: 600 }}>
                  {t("Upload File")} <span style={{ color: "#CF5C5C" }}>*</span>
                </Typography>
                <span
                  style={{
                    marginTop: "-20px",
                    fontSize: "10px",
                    fontWeight: 400,
                  }}
                >
                  ( PDF file Only)
                </span>
              </Grid>

              <Grid item xs={4}>
                <Button
                  variant="contained"
                  component="label"
                  style={{
                    marginLeft: "auto",
                    color: "white",
                    width: "100%",
                    height: "33px",
                  }}
                  htmlFor="lab-report"
                >
                  {t("Upload")}
                </Button>
                <input
                  type="file"
                  id="lab-report"
                  name="lab_report"
                  accept="application/pdf"
                  onChange={onFileChange}
                  style={{ display: "none" }}
                />
              </Grid>
            </Grid>
            {selectedFileName && <CustomValue> {selectedFileName}</CustomValue>}
            <CustomButton onClick={createLabTest}>
              {isEdit ? t("Save") : t("Add Lab Test")}
            </CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
